<template>
  <div class='details'>
    <div class="YTitle">消息发送详情</div>

    <div class="form YFrom2">
      <el-form :label-width='`${ 200 / 192 }rem`'>
        <el-form-item label="消息标题：">{{data.notifyTitle}}</el-form-item>
        <el-form-item label="消息发送人：">{{data.createUserRealName}}</el-form-item>
        <el-form-item label="消息发送时间：">{{data.createTime}}</el-form-item>
        <el-form-item label="消息内容：">
          <div v-html="data.instantiationValue"></div>
        </el-form-item>
        <el-form-item label="消息发送对象：">{{data.targetObjects}}</el-form-item>
        <el-form-item label="消息回复详情：" v-if="data.notifyInstantiationReplies.length > 0">
          <el-timeline>
            <el-timeline-item :timestamp="`${item.replyUserName}（${item.createTime}）`" placement="top" v-for="item in data.notifyInstantiationReplies" :key="item.id">
              <el-card>
                <p>{{item.content}}</p>
                <div class="imgList">
                  <img :src="img.url" :alt="img.name" v-for="img in JSON.parse(item.images)" :key="img.uid">
                </div>
              </el-card>
            </el-timeline-item>
          </el-timeline>
        </el-form-item>
      </el-form>
    </div>

    <div class="btn">
      <el-button type="success" @click="reply" round>回复</el-button>
      <el-button type="primary" round @click="colse">返回</el-button>
    </div>

    <YModal
      title='消息回复'
      @close='YModalClsoe'
      :show.sync='YModalShow'>
      <el-form ref="rules" :rules="rules" :model="formInline">
        <el-form-item label="活动形式：" prop="content">
          <el-input type="textarea" :rows="3" v-model="formInline.content"></el-input>
        </el-form-item>
        <el-form-item label="图片上传：">
          <YUpload
            type='picture'
            remark='只能上传jpg/png文件，且不超过5MB'
            v-model='formInline.images'>
          </YUpload>
        </el-form-item>
        <div class="btn">
          <el-button type="success" @click.stop="submit" round>提交</el-button>
          <el-button type="primary" round @click="YModalClsoe">返回</el-button>
        </div>
      </el-form>
    </YModal>
  </div>
</template>

<script>
import api from '@/shared/api/apps/news'
export default {
  name: 'Details',

  props: {
    DetailsData: {
      type: Object,
      default () {
        return {}
      }
    }
  },

  data () {
    return {
      data: {
        notifyInstantiationReplies: []
      },
      YModalShow: false,
      formInline: {
        content: '',
        images: []
      },
      rules: {
        content: [
          { required: true, message: '请输入回复内容', trigger: 'blur' }
        ]
      }
    }
  },

  mounted () {
    this.init()
  },

  methods: {
    init () {
      this.getdata()
    },

    getdata () {
      const params = {
        method: api.details,
        id: this.DetailsData.id
      }

      this.axios.post(params).then(res => {
        if (res.data.backend_odc_notify_instantiation_get_response.code !== '10000') return
        this.data = res.data.backend_odc_notify_instantiation_get_response.result
      })
    },

    colse () {
      this.$emit('close')
    },

    reply () {
      this.YModalShow = true
    },

    YModalClsoe () {
      this.YModalShow = false
    },

    submit () {
      this.$refs.rules.validate((valid) => {
        if (valid) {
          const params = {
            method: api.reply,
            content: this.formInline.content,
            images: JSON.stringify(this.formInline.images),
            instantiationId: this.DetailsData.id,
            replyUserName: JSON.parse(sessionStorage.getItem('User')).realName
          }

          this.axios.post(params).then(res => {
            if (res.data.backend_odc_notify_instantiation_reply_response.code !== '10000') return
            this.$message({
              message: '消息回复成功',
              type: 'success'
            })
            this.YModalClsoe()
            this.getdata()
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    }
  }
}
</script>

<style lang='stylus' scoped>
  .details
    position absolute
    top 0
    left 0
    width 100%
    height 100%
    background #ffffff
    z-index 1
    display flex
    flex-direction column
    .form
      flex auto
      overflow auto
      margin-top 20px
      padding-right 20px
      .info-tag
        margin-right 20px
        margin-top 10px
      .imgList
        display flex
        flex-wrap wrap
        img
          height 100px
          padding 10px
    .btn
      margin 20px 0
      text-align center
</style>
